import React from "react"
import styled from "@emotion/styled"
import Button from "../Button/button"
import SportsList from "../SportsList/sportsList"

import "./textBlock.scss"

const textBlock = props => {
  const TextBlockWrapper = styled("div")`
    &.light {
      h2 {
        color: #000;
      }
      .body-copy,
      .text-block__promotion,
      .disclaimer {
        p,
        a {
          color: #000;
        }
      }
    }
  `

  return (
    <TextBlockWrapper className={`text-block ${props.color_theme}`}>
      <div className="container">
        {props.include_badge_image && (
          <img
            className="text-block__badge-image"
            src={props.badge_image.url}
            alt=""
          />
        )}
        <h2 className="headline"> {props.headline} </h2>
        <div
          className="body-copy"
          dangerouslySetInnerHTML={{ __html: props.body_copy }}
        />
        {props.reference.length !== 0 && (
          <div className="button__container">
            {props.reference.map((data, index) => {
              switch (data.__typename) {
                case "Contentstack_button":
                  return (
                    <Button
                      key={index}
                      button_link={data.button_link.href}
                      button_link_type={data.button_link_type}
                      button_text={data.button_text}
                      button_color={data.button_color}
                      button_type={data.button_type}
                      className={
                        data.button_type === "square button" &&
                        "button__sign-up"
                      }
                      color_theme={props.color_theme}
                      text_color={data.text_color}
                    />
                  )
                case "Contentstack_sports_list":
                  return <SportsList key={index} {...data} />
                default:
                  return null
              }
            })}
          </div>
        )}
        {props.promotional_text !== null &&
          props.promotional_text !== undefined &&
          props.promotional_text[0] && (
            <>
              <p className="text-block__promotion">
                {props.promotional_text[0].mkt_copy}
                <br />
                {props.promotional_text[0].subhead}
              </p>
              <p className="disclaimer">
                {props.promotional_text[0].legal_copy}
              </p>
            </>
          )}
      </div>
    </TextBlockWrapper>
  )
}

export default textBlock
